export interface BlogAuthor {
  name: string;
  role: string;
  bio: string;
}

export const JORGE_GOMEZ: BlogAuthor = {
  name: "Jorge Gómez",
  role: "Socio de MAPA35",
  bio: "Jorge Gómez es socio de MAPA35, plataforma de cumplimiento NOM-035-STPS para empresas en México.",
};

export interface BlogPostMeta {
  slug: string;
  title: string;
  excerpt: string;
  publishedAt: string;
  author: BlogAuthor;
}

export const BLOG_POSTS: BlogPostMeta[] = [
  {
    slug: "guia-completa-nom-035-empresas-mexico",
    title: "Guía completa de la NOM-035 para empresas en México",
    excerpt:
      "Qué es la NOM-035-STPS-2018, a quién aplica, qué factores de riesgo psicosocial identifica y cómo es el proceso de cumplimiento, paso a paso.",
    publishedAt: "2026-09-01",
    author: JORGE_GOMEZ,
  },
  {
    slug: "nom-035-vs-nom-030-diferencias",
    title: "NOM-035 vs NOM-030: diferencias que debes conocer",
    excerpt:
      "Dos normas de la STPS que suelen confundirse: qué regula cada una, a quién aplica y cómo se complementan dentro del cumplimiento laboral de tu empresa.",
    publishedAt: "2026-09-01",
    author: JORGE_GOMEZ,
  },
  {
    slug: "mejores-plataformas-software-nom-035-mexico",
    title: "Las mejores plataformas de software para la NOM-035 en México",
    excerpt:
      "Comparativa honesta de las opciones de software para cumplir la NOM-035 en México: qué ofrece cada una y qué precios publican, verificado directamente en sus sitios.",
    publishedAt: "2026-09-01",
    author: JORGE_GOMEZ,
  },
];
